import { WalletType } from "common/types";

import { walletDisplayText } from "client/payments/utils";
import Loading from "client/common/components/loading/Loading";
import Dialog from "client/common/components/stackables/Dialog";

import styles from "../styles/WalletCheckoutDialog.module.less";

const noop = () => undefined;

type WalletPaymentDialogProps = {
  isVisible: boolean;
  wallet: WalletType;
};

/**
 * A dialog to overlay over the main checkout, this is a special case which
 *  we want to unconditionally display this while the wallet checkout is completing.
 * */
const WalletCheckoutDialog = ({ isVisible, wallet }: WalletPaymentDialogProps) => {
  return (
    <Dialog.Standalone isVisible={isVisible} onClose={noop}>
      <div className={styles.dialog}>
        <h2 className={styles.title}>Placing order with {walletDisplayText(wallet)}...</h2>
        <p className={styles.description}>Please wait while we process your payment</p>
        <Loading />
      </div>
    </Dialog.Standalone>
  );
};

export default WalletCheckoutDialog;
